/*
  Utilities for handling external diagnoses
 */

const partialDateToDate = date => new Date(date[0] || 0, date[1] ? date[1] - 1 : 0, date[2] || 1);

const sortPartialDate = (dateA, dateB) => {
  const d1 = partialDateToDate(dateA);
  const d2 = partialDateToDate(dateB);

  return d2 - d1;
};

const MS_CODES = ['G35'];
const KEO_CODES = [
  'KEO', // This is what we map SQ MS codes to since the actual code is not returned
  'G36.9',
  'G37.9',
  'G36.0',
  'radiologicallyIsolatedSyndrome',
];

const allDgCodes = [...MS_CODES, ...KEO_CODES];

export const getLatestRankedDiagnosis = diagnoses => {
  if (!diagnoses || !Array.isArray(diagnoses)) return null;

  const relevantDiagnoses = diagnoses.filter(dg => {
    if (!dg.date || typeof dg.date[0] !== 'number' || !dg.diagnosis) return false;

    if (!allDgCodes.includes(dg.diagnosis)) return false;
    return true;
  });

  const flattenedDiagnoses = relevantDiagnoses.flatMap(dg => {
    const diagnosis = MS_CODES.includes(dg.diagnosis) ? 'ms' : 'keo';

    if (dg.typeOfDisease && Array.isArray(dg.typeOfDisease) && dg.typeOfDisease.length > 0) {
      const normalizedDgs = dg.typeOfDisease
        .filter(td => Array.isArray(td.date) && td.date[0] !== null && td.type)
        .map(td => ({ date: td.date, diagnosis: diagnosis, type: td.type }));

      if (normalizedDgs.length < 1) normalizedDgs.push({ date: dg.date, diagnosis: diagnosis, type: null });

      return normalizedDgs;
    }

    return { date: dg.date, diagnosis: diagnosis, type: null };
  });

  const sortedDates = flattenedDiagnoses.sort((a, b) => sortPartialDate(a.date, b.date));
  return sortedDates.find(dg => dg.diagnosis === 'ms') || sortedDates.find(dg => dg.diagnosis === 'keo');
};
